import { useQuery } from '@tanstack/react-query'
import { postNamedQuery } from '../../../../../../service'

export const useGetInfographicBlockDetails = (body = {}, options = {}) => {
  const { mapper = null, enabled = true } = options ?? {}
  return useQuery({
    queryKey: ['reports', 'getInfographicBlockDetails', body],
    queryFn: async () => {
      const { data } = await postNamedQuery('reports', 'get-infographic-block-details', body)
      return data
    },
    enabled,
    mapper: mapper ?? ((data) => data?.data ?? [])
  })
}
